import React from 'react';
import { Card, Empty, List, Spin, Typography } from 'antd';
import { useQuery } from '@tanstack/react-query';
import { Link, useParams } from 'react-router-dom';
import hrmsService from '@/services/hrms.service';

const { Title, Paragraph, Text } = Typography;

const CareersListPage: React.FC = () => {
  const { slug } = useParams<{ slug: string }>();
  const { data, isLoading, error } = useQuery({
    queryKey: ['public-careers', slug],
    queryFn: () => hrmsService.listPublicJobs(slug!),
    enabled: Boolean(slug),
  });

  const settings = (data as any)?.settings || data;
  const jobs = (data as any)?.jobs || (Array.isArray(data) ? data : []);

  if (isLoading) {
    return (
      <div style={{ maxWidth: 720, margin: '48px auto', padding: 16, textAlign: 'center' }}>
        <Spin />
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ maxWidth: 720, margin: '48px auto', padding: 16 }}>
        <Empty description={(error as any)?.response?.data?.message || 'Careers page unavailable'} />
      </div>
    );
  }

  return (
    <div style={{ maxWidth: 720, margin: '0 auto', padding: '32px 16px' }}>
      <Title level={2} style={{ marginBottom: 4 }}>
        {(settings as any)?.brand_title || 'Careers'}
      </Title>
      {(settings as any)?.brand_tagline && (
        <Paragraph type="secondary">{(settings as any).brand_tagline}</Paragraph>
      )}
      <List
        dataSource={jobs}
        locale={{ emptyText: 'No open positions' }}
        renderItem={(job: any) => (
          <List.Item>
            <Card size="small" style={{ width: '100%' }}>
              <Link to={`/careers/${slug}/jobs/${job.slug}`}>
                <Text strong style={{ fontSize: 16 }}>
                  {job.title}
                </Text>
              </Link>
              <div>
                <Text type="secondary">
                  {[job.location_text, job.employment_type].filter(Boolean).join(' · ')}
                </Text>
              </div>
            </Card>
          </List.Item>
        )}
      />
    </div>
  );
};

export default CareersListPage;
